/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from '~/lib/utils'
import Container from '../Container'
import Full from '../Full'

import { ComponentRenderer } from '../renderers/comp/thirdsComponents'
import { useQuery } from '@tanstack/react-query'
import { getEntriesByIds } from '~/lib/contensis/misc'
// import Loader from '~/components/UI/General/Loader/Loader'

const ThirdsLayout = ({ content, padding, avantGarde }: any) => {
  const componentGroups = [
    content?.component || [],
    content?.component2 || [],
    content?.component3 || []
  ]

  const componentIds = componentGroups
    .flat()
    .map((c: any) => c?.sys?.id)
    .filter(Boolean)

  const { data } = useQuery({
    queryKey: ['layout-thirds', componentIds],
    queryFn: async () => {
      return componentIds.length ? getEntriesByIds(componentIds) : []
    },
    enabled: componentIds.length > 0
  })

  // if (isLoading)
  //   return (
  //     <div className='py-l flex w-full justify-center'>
  //       <Loader fill={'#f5b6dc'} />
  //     </div>
  //   )
  // if (error) return <div>Error loading components</div>

  // Map fetched data by id for quick lookup
  const dataById = Array.isArray(data)
    ? data.reduce((acc: Record<string, any>, entry: any) => {
        acc[entry?.sys?.id] = entry
        return acc
      }, {})
    : {}

  // Replace each group with hydrated data if available
  const hydratedGroups = componentGroups.map(group =>
    group.map((item: any) => dataById[item?.sys?.id] || item)
  )
  return (
    <>
      <Container columns='default' padding={padding} config={content}>
        {hydratedGroups.map((group, groupIdx) => (
          <Full
            key={groupIdx}
            className={cn(
              'w-full sm:max-lg:mx-auto sm:max-lg:max-w-2/3',
              content.verticalAlignment === 'top' ? 'md:top-3xl md:sticky' : ''
            )}
          >
            {group.map((item: any, index: number) => (
              <ComponentRenderer
                key={index}
                components={item}
                layoutColour={content.backgroundColour || 'white'}
                avantGarde={avantGarde}
                layoutPosition={groupIdx}
              />
            ))}
          </Full>
        ))}
        {/* <Full
          className={cn(
            'w-full sm:max-lg:mx-auto sm:max-lg:max-w-2/3',
            content.verticalAlignment === 'top' ? 'md:top-3xl md:sticky' : ''
          )}
        >
          {content.component.map((item: any, index: Index) => (
            <ComponentRenderer
              key={index}
              components={item}
              layoutColour={content.backgroundColour || 'white'}
              avantGarde={avantGarde}
            />
          ))}
        </Full>
        <Full
          className={cn(
            'w-full sm:max-lg:mx-auto sm:max-lg:max-w-2/3',
            content.verticalAlignment === 'top' ? 'md:top-3xl md:sticky' : ''
          )}
        >
          {content.component2.map((item: any, index: Index) => (
            <ComponentRenderer
              key={index}
              components={item}
              layoutColour={content.backgroundColour || 'white'}
              avantGarde={avantGarde}
            />
          ))}
        </Full>
        <Full
          className={cn(
            'w-full sm:max-lg:mx-auto sm:max-lg:max-w-2/3',
            content.verticalAlignment === 'top' ? 'md:top-3xl md:sticky' : ''
          )}
        >
          {content.component3.map((item: any, index: Index) => (
            <ComponentRenderer
              key={index}
              components={item}
              layoutColour={content.backgroundColour || 'white'}
              avantGarde={avantGarde}
            />
          ))}
        </Full> */}
      </Container>
    </>
  )
}

export default ThirdsLayout
